import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBox = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.75 3.75V2.5H7.5V3.75H10V5H7.5V12.5H10V13.75H7.5V15H13.75V13.75H11.25V12.5H13.75V5H11.25V3.75H13.75ZM8.75 11.25V9.375H12.5V11.25H8.75ZM12.5 8.125H8.75V6.25H12.5V8.125Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.75 18.75H2.5C2.16848 18.75 1.85054 18.6183 1.61612 18.3839C1.3817 18.1495 1.25 17.8315 1.25 17.5V1.25H2.5V17.5H18.75V18.75Z",
		fill: "currentColor"
	})]
});
export default SvgBox;
